//natives
import React from 'react';
import Switch from '@material-ui/core/Switch';

export default (props) => [
    {
        label: "Ativo",
        name: "value",
        options: {
            customBodyRender: data => {
                return (
                    <Switch 
                        size="small" 
                        checked={data.value} 
                        onChange={()=>{
                            props.handlerSwitch(data.id_md5)
                        }}
                    />
                );
            },
        }
    },
    {
        label: "Descrição",
        name: "descricao",
    },
];